import { StandardCarousel } from '../../../../components/carousel/StandardCarousel';
import { Feedback } from './feedbacks';
import { FeedbackCard } from './FeedbackCard';

type FeedbackCarouselProps = {
  feedbacks: Feedback[];
  direction?: 'left' | 'right';
};

export const FeedbackCarousel = ({
  feedbacks,
  direction = 'left',
}: FeedbackCarouselProps) => {
  const feedbackCards = feedbacks.map((feedback, index) => (
    <FeedbackCard key={`${feedback.name}-${index}`} feedback={feedback} />
  ));

  return (
    <StandardCarousel direction={direction} animationDuration={80}>
      {feedbackCards}
    </StandardCarousel>
  );
};
